/**
 * Url Ref: http://docs.parseplatform.org/js/guide/#error-codes
 */
export const ERROR_MSG = {
  100: "Error de conexión con Parse",
  101.1: "Correo electrónico o contraseña invalido",
  101: "Objeto no encontrado",
  102: "Query invalido",
  103: "Nombre de clase invalido o no existe",
  104: "ObjectId inexistente",
  105: "Campo invalido, a-zA-Z0-9_ caracteres aceptados",
  106: "Referencia (pointer) invalido",
  107: "JSON invalido",
  108: "Comando no permitido",
  109: "No inicializado usar Parse.initialize",
  111: "Tipo de dato incorrecto",
  116: "El objeto es demasiado largo, excede los 100 caracteres",
  117: "Error de limite invalido",
  118: "Error de skip invalido",
  119: "Operación no permitida, permisos requeridos",
  120: "Resultado no encontrado en el cache",
  121: "Key invalida usada para anidar el JsonObject",
  123: "ACL invalido",
  125: "Correo electrónico invalido",
  137: "Valor duplicado",
  139: "Nombre de rol invalido o campo reservado",
  140: "Excedio el limite de clases creadas",
  141: "Fallo el script, función o job no encontrado",
  142: "Fallo la validación de la función cloud",
  143: "Error de WebHook",
  150: "Datos de la imagen inválidos",
  151: "Error al guardar un archivo",
  152: "Error PushTime invalido",
  158: "Error de Hosting",
  160: "Nombre de evento invalid",
  200: "Falta nombre de usuario",
  201: "Falta contraseña",
  202: "El usuario existe",
  203: "Correo electrónico existe",
  204: "El correo electrónico debe ser especificado",
  205: "Usuario con correo electrónico especificado no existe",
  206: "Error de sesión para el usuario actual",
  207: "El usuario debe ser creado mediante el formulario de registro",
  208: "La cuenta ya fue enlazada",
  209: "Token de sesión invalido",
  902: "Falta API key",
  903: "API key invalido",
  //Own Error codes
  undefined: "Ocurrió un error inesperado por favor, intente de nuevo.",
  SERVER_ERROR: "Ocurrió un error inesperado por favor, intente de nuevo.",

  // waiter
  FILTER_NOT_FOUND: "Filtro no encontrado.",
  FILTER_CANT_DELETED: 'El filtro no pudo ser eliminado.',
  FILTER_CANT_SAVE: 'El filtro no pudo ser guardado.',
  TABLE_NOT_FOUND: 'Mesa no encontrada',
  WORKLAPSE_NOT_FOUND: "El lapso de trabajo no pudo ser encontrado.",
  WORKLAPSE_CANT_DELETED: 'El lapso de trabajo no pudo ser eliminado.',
  RESERVATION_NOT_FOUND: "Reservación no encontrada..",
  RESERVATION_DATE_INVALID: 'Hora no valida para reserva de esta mesa',
  RESERVATION_CANT_SAVE: 'Error al guardar la reserva.',

  // user session branch
  USER_NOT_FOUND: "Usuario no encontrado.",
  BRANCH_NOT_FOUND: "Debe seleccionar una sucursal.",

  // orders
  ORDER_NOT_FOUND: 'Orden no encontrada',
  ORDER_CANT_UPDATED: 'La order no pudo ser actualizada.',
  ORDER_STATUS_INVALID: 'Estado de orden inválido.',
  PAYMENT_METHOD_INVALID: 'Hora no valida para reserva de esta mesa',
  ORDER_ALREADY_PAID: 'El pedido ya fue pagado',
  CANT_CHANGE_TO_ONLINE_PAYMENT: 'No se puede cambiar a pago online',

  // product
  PRODUCT_NOT_AVAILABLE: 'La disponibilidad del producto no pudo ser encontrado.',
  CANT_SAVE_PRODUCT_AVAILABILITY: 'La disponibilidad del producto no pudo ser actualizada.',
  PRODUCT_NOT_FOUND: 'Producto no encontrado',

  // drivers
  DRIVER_NOT_FOUND: 'Driver no encontrado',
}

export const SUCCESS_MSG = {
  SUCCESS: "Agregado exitosamente",
  SEND_MAIL: "Correo electrónico enviado exitosamente, revise su correo",
  SUCCESS_DELETED: "Eliminado exitosamente",
  SUCCESS_UPDATED: "Modificado exitosamente"
}
